export default function buildDeleteListingTag({
    apiEndpoint,
    apiTools
}) {
    return async function deleteListingTag(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }` 
        })
       
        const res = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}